module.exports = __webpack_public_path__ + "img/visa.907f91a3.png";